import { createContext, useContext } from 'react';
import type { PublicQuoteLocale } from '@/lib/publicQuoteLocale';

/**
 * Klantgegevens voor de blokken in het gedeelde offertedocument: status,
 * handtekeningen en (alleen online) de acties om te ondertekenen. De PDF
 * krijgt dezelfde gegevens zonder acties, zodat beide dezelfde pagina tonen.
 */
export interface QuotePublicView {
  quoteStatus?: string;
  publicLocale?: PublicQuoteLocale;
  boxSignStatus?: string | null;
  boxSignedAt?: string | null;
  existingSignature?: string | null;
  onSignature?: (dataUrl: string | null) => void;
  onAccept?: () => void;
  acceptLoading?: boolean;
  onSignAsRecipient?: (recipientId: string, signatureDataUrl: string) => void;
  signingRecipientId?: string | null;
}

const QuotePublicViewContext = createContext<QuotePublicView | null>(null);

export const QuotePublicViewProvider = QuotePublicViewContext.Provider;

/** null in de builder: daar is het document geen klantweergave. */
export function useQuotePublicView(): QuotePublicView | null {
  return useContext(QuotePublicViewContext);
}
